/**
 * events — CustomEvent dispatchers for the variant picker.
 *
 * All events bubble so parent components (backorder banner, price block, etc.)
 * can listen on a containing element.
 */

/**
 * Dispatched when the resolved variant changes.
 * detail.fallbackFrom is set when the exact selection couldn't be honored.
 *
 * @param {HTMLElement} target
 * @param {{ variant: object, selection: Record<string,string>, fallbackFrom?: Record<string,string>, form: HTMLElement|null }} detail
 */
export function dispatchVariantChange(target, detail) {
  target.dispatchEvent(
    new CustomEvent('on:variant:change', {
      bubbles: true,
      detail,
    })
  );
}

/**
 * Dispatched when the engine determines a cross-product redirect is needed.
 * The host page should navigate to detail.url (or intercept for quick-buy).
 *
 * @param {HTMLElement} target
 * @param {{ url: string, handle: string, selection: Record<string,string> }} detail
 */
export function dispatchVariantRedirect(target, detail) {
  target.dispatchEvent(
    new CustomEvent('on:variant:redirect', {
      bubbles: true,
      detail,
    })
  );
}

/**
 * Dispatched once after the element has connected and completed hydration.
 *
 * @param {HTMLElement} target
 * @param {{ variant: object|null, selection: Record<string,string> }} detail
 */
export function dispatchPickerReady(target, detail) {
  target.dispatchEvent(
    new CustomEvent('on:picker:ready', {
      bubbles: true,
      detail,
    })
  );
}
